import React from 'react';
import { Redirect } from 'react-router-dom'
import { Routes } from '../routes';
import { ExternalAuthentication } from '@trustpilot/ecommscript-integrationappauth/external-authentication';

const integrationsExternalAuthAppClientId = process.env.REACT_APP_IntegrationsExternalAuthAppClientId!;
const integrationsExternalAuthAuthenticationApiUrl = process.env.REACT_APP_IntegrationsExternalAuthAuthenticationApiUrl!;
const integrationsExternalAuthCookiesDomain = process.env.REACT_APP_IntegrationsExternalAuthCookiesDomain!;
const integrationsExternalAuthTrustpilotDomain = process.env.REACT_APP_IntegrationsExternalAuthTrustpilotDomain!;

interface LoginFormProps {
  isLoggedIn: boolean;
  onLoggedInChange: (loggedIn: boolean) => void;
}

const LoginForm: React.FunctionComponent<LoginFormProps> = ({ isLoggedIn, onLoggedInChange }) => {
  if (isLoggedIn) {
    return <Redirect to={Routes.ADMIN_UI}/>;
  }

  return (
    <ExternalAuthentication
      source="zendeskappui"
      locale="en-US"
      trustpilotDomain={integrationsExternalAuthTrustpilotDomain}
      appClientId={integrationsExternalAuthAppClientId}
      redirectUri={window.location.origin}
      cookiesDomain={integrationsExternalAuthCookiesDomain}
      authenticationApiUrl={integrationsExternalAuthAuthenticationApiUrl}
      onLoggedIn={onLoggedInChange}
    />);
};

export default LoginForm;
